import './testimonial.css'
import testimonialsImg1 from '../../assets/images/testimonials-img-1.png'
import testimonialsImg2 from '../../assets/images/testimonials-img-2.png'
import testimonialsShape from '../../assets/images/testimonials-shape.png'

const Testimonial = () => {
    return (
        <div className="testimonials-area pt-100 pb-70">
            <div className="container">
                <div className="section-title section-title-left">
                    <span className="top-title">Our Testimonial</span>
                    <h2>What People Are Saying!</h2>
                </div>
                <div className="testimonials-slider">
                    <div className="single-testimonials-card">
                        <i className="flaticon-quote"></i>
                        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui praesentium voluptatum deleniti atque corrupti quos dolo rese quas moleum stias excepturi sint occaecati cupiditate non provident et odio dignissimos ducimus qui blanditiis.</p>
                        <div className="testimonials-text">
                            <a href="#">
                                <img src={testimonialsImg1} alt="images" />
                            </a>
                            <div className="testimonials-bg-content">
                                <a href="#">
                                    <h3>Anthony Dylan</h3>
                                </a>
                                <p>Cleaning Expert</p>
                            </div>
                        </div>
                        <div className="testimonials-shape">
                            <img src={testimonialsShape} alt="images" />
                        </div>
                    </div>
                    <div className="single-testimonials-card">
                        <i className="flaticon-quote"></i>
                        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui praesentium voluptatum deleniti atque corrupti quos dolo rese quas moleum stias excepturi sint occaecati cupiditate non provident et odio dignissimos ducimus qui blanditiis.</p>
                        <div className="testimonials-text">
                            <a href="#">
                                <img src={testimonialsImg2} alt="images" />
                            </a>
                            <div className="testimonials-bg-content">
                                <a href="#">
                                    <h3>Sofia Avery</h3>
                                </a>
                                <p>Cleaning Expert</p>
                            </div>
                        </div>
                        <div className="testimonials-shape">
                            <img src={testimonialsShape} alt="images" />
                        </div>
                    </div>
                    <div className="single-testimonials-card">
                        <i className="flaticon-quote"></i>
                        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui praesentium voluptatum deleniti atque corrupti quos dolo rese quas moleum stias excepturi sint occaecati cupiditate non provident et odio dignissimos ducimus qui blanditiis.</p>
                        <div className="testimonials-text">
                            <a href="#">
                                <img src={testimonialsImg1} alt="images" />
                            </a>
                            <div className="testimonials-bg-content">
                                <a href="#">
                                    <h3>Anthony Dylan</h3>
                                </a>
                                <p>Cleaning Expert</p>
                            </div>
                        </div>
                        <div className="testimonials-shape">
                            <img src={testimonialsShape} alt="images" />
                        </div>
                    </div>
                    <div className="single-testimonials-card">
                        <i className="flaticon-quote"></i>
                        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui praesentium voluptatum deleniti atque corrupti quos dolo rese quas moleum stias excepturi sint occaecati cupiditate non provident et odio dignissimos ducimus qui blanditiis.</p>
                        <div className="testimonials-text">
                            <a href="#">
                                <img src={testimonialsImg2} alt="images" />
                            </a>
                            <div className="testimonials-bg-content">
                                <a href="#">
                                    <h3>Sofia Avery</h3>
                                </a>
                                <p>Cleaning Expert</p>
                            </div>
                        </div>
                        <div className="testimonials-shape">
                            <img src={testimonialsShape} alt="images" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonial